<template>
  <div>
    <div class="d-flex justify-space-between align-center pa-4 pa-md-2">
      <Breadcrumbs
        headline="Bảo Lưu"
        :link="[{ text: 'Bảo lưu', href: '../reservation' }]"
      />
    </div>

    <v-card class="pa-2 pa-md-2 mx-md-2">
      <v-data-table
        item-key="id"
        v-model="selected"
        :options.sync="studentTableOptions"
        :server-items-length="totalItems"
        :headers="headers"
        :items="students"
        :items-per-page="10"
        :footer-props="{
          itemsPerPageOptions: [10, 15, 20, 30]
        }"
        dense
      >
        <template v-slot:item.status="{ item }">
          <v-chip
            v-if="item.status"
            small
            dark
            :color="getColor(item.status)"
            >{{ item.status | getStatus }}</v-chip
          >
        </template>
        <template v-slot:item.name="{ item }">
          <card-student-name :student="item" link />
        </template>
        <template v-slot:item.action="{ item }">
          <v-btn text icon @click="onStudentSelected(item)">
            <v-icon dense>mdi-pencil</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.reservation="{ item }">
          <span style="white-space: nowrap;">{{
            item.reservation | familiarizeStartDate
          }}</span>
        </template>
        <template v-slot:item.reservation.endDate="{ item }">
          <span style="white-space: nowrap;">{{
            item.reservation | familiarizeEndDate
          }}</span>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue'
import moment from 'moment'
export default {
  components: {
    CardStudentName,
    Breadcrumbs
  },
  props: {
    role: String
  },
  data() {
    return {
      headers: [
        { text: 'Tên', value: 'name', align: 'left', sortable: false },
        { text: 'Email', value: 'email', align: 'left', sortable: false },
        {
          text: 'Số điện thoại',
          value: 'phone',
          align: 'left',
          sortable: false
        },
        {
          text: 'Ngày bảo lưu',
          value: 'reservation',
          align: 'left',
          sortable: false
        },
        {
          text: 'Hạn bảo lưu',
          value: 'reservation.endDate',
          align: 'left',
          sortable: false
        }
      ],
      selected: [],
      draw: false,
      search: '',
      status: null,
      statuses: [
        { text: 'Active', value: 'false' },
        { text: 'Blocked', value: 'true' }
      ],
      range: { from: null, to: null },
      previewUserId: null,
      ready: false,
      studentTableOptions: {}
    }
  },
  mounted() {
    this.clean()
    this.searchOptionsChanged({ status: 'reserved' })
  },
  computed: {
    ...mapState('app', ['department']),
    ...mapState('students', ['totalItems', 'students'])
  },
  methods: {
    ...mapActions('students', [
      'requestPageSettings',
      'searchStudents',
      'clean'
    ]),
    updateDraw(draw) {
      this.draw = draw
    },
    getColor(status) {
      if (status === 'active') return 'green'
      if (status === 'reserved') return 'orange'
      else return 'gray'
    },
    searchOptionsChanged(searchOptions) {
      this.searchStudents({ ...searchOptions, status: 'reserved' })
    },

    getTuitionStatus(leads) {
      if (!leads) return ''
      return leads.map(lead => lead.liabilities).reduce((a, b) => a + b, 0) >= 0
        ? ''
        : 'Nợ'
    }
  },
  watch: {
    studentTableOptions: {
      handler(newOptions, oldOptions) {
        const itemPerPageChanged =
          newOptions.itemsPerPage !== oldOptions.itemsPerPage
        const pageChanged = newOptions.page !== oldOptions.page
        if (pageChanged || itemPerPageChanged) {
          this.requestPageSettings({
            page: newOptions.page,
            itemsPerPage: newOptions.itemsPerPage
          })
        }
      },
      deep: true
    }
  },
  filters: {
    getStatus(status) {
      if (status === 'reserved') return 'Bảo Lưu'
      if (status === 'active') return 'Hoạt Động'
      return status
    },
    familiarizeStartDate: time => {
      if (!time || !time.startDate) {
        return ''
      }
      return moment(time.startDate).format('DD/MM/YYYY')
    },
    familiarizeEndDate: time => {
      if (!time || !time.endDate) {
        return ''
      }
      return moment(time.endDate).format('DD/MM/YYYY')
    }
  }
}
</script>
<style scoped>
td {
  white-space: nowrap !important   ;
}
</style>
